var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExclamationCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 49 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 14a2 2 0 1 1 4 0v12a2 2 0 1 1-4 0zm4 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M24.5 42.5C34.717 42.5 43 34.217 43 24S34.717 5.5 24.5 5.5 6 13.783 6 24s8.283 18.5 18.5 18.5M46 24c0 11.874-9.626 21.5-21.5 21.5S3 35.874 3 24 12.626 2.5 24.5 2.5 46 12.126 46 24",
  clipRule: "evenodd"
})));
export default SvgExclamationCircle;